<script lang="ts" setup>
withDefaults(
    defineProps<{
        title?: string;
        footer?: string;
        variant?: 'default' | 'danger';
        divided?: boolean;
    }>(),
    {
        title: '',
        footer: '',
        variant: 'default',
        divided: true,
    },
);
</script>

<template>
    <section class="space-y-1.5">
        <div
            v-if="title || $slots['header-action']"
            class="flex items-center justify-between px-1 pb-0.5"
        >
            <h3
                class="text-sm font-medium"
                :class="variant === 'danger' ? 'text-red-700' : 'text-gray-700'"
            >
                {{ title }}
            </h3>
            <slot name="header-action" />
        </div>

        <div
            class="overflow-hidden rounded-lg border bg-white shadow-sm"
            :class="[
                variant === 'danger' ? 'border-red-200' : 'border-gray-200',
                divided ? 'divide-y divide-gray-100' : '',
            ]"
        >
            <slot />
        </div>

        <slot name="footer">
            <p v-if="footer" class="px-1 text-xs leading-relaxed text-gray-500">
                {{ footer }}
            </p>
        </slot>
    </section>
</template>
